import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VuePlyr from 'vue-plyr'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import i18n from './locales'
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false

const lang = store.state.language
if (lang) {
  i18n.locale = lang
}

Vue.use(VuePlyr)
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VTooltip)

Vue.router = router

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
